import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { appCtx } from 'components/appStore';
import WarningBanner from 'components/assessments_pages/WarningBanner';
import ButtonBase from '@mui/material/ButtonBase';

const CandidateFeedbackBanner = observer(({ interviewSlug, history }) => {
    const { loggedUser: { roleType: userRoleType } } = useContext(appCtx);

    const hasEditPermissions = (userRoleType === 'owner' || userRoleType === 'admin');

    const onButtonClick = () => {
        history.push({
            pathname: '/company-account',
            state: { scrollToEnd: true }
        });
    };

    return (
        <WarningBanner
            isDissmisable
            id={interviewSlug}
            label={
                hasEditPermissions
                    ? (
                        <>
                            <b>Candidate Feedback feature has been turned off.</b>&nbsp;
                            <ButtonBase onClick={onButtonClick}>
                                Authorize from the company account.
                            </ButtonBase>
                        </>
                    )
                    : (
                        <>
                            <b>Candidate Feedback feature has been turned off.</b>&nbsp;
                            <span>
                                        Contact your admin to authorize.
                            </span>
                        </>
                    )

            }
        />
    );
});

export default CandidateFeedbackBanner;
